import { Grid, Typography, useMediaQuery } from "@mui/material";
import { CrossIcon, FeaturedIcon } from "../../assets/customIcons";
import { MuiButton } from "../../components";
import { MuiIconButton } from "../../components/atoms/iconButtonComponent";
import { faintblue, faintGray, gray, mobilenoblack } from "../../theme/palette";
import { getTimeInHMS } from "../../utils/utils";
export var DelayedPopup = function (props) {
    var IS_MOBILE = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var onClose = props.onClose, difference = props.difference, estimatedDeliveryTime = props.estimatedDeliveryTime, jobcardNo = props.jobcardNo, documentDateTime = props.documentDateTime;
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        gap: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(FeaturedIcon, {
        sx: {
            height: '48px',
            width: '48px'
        }
    }), /*#__PURE__*/ React.createElement(MuiIconButton, {
        sx: {
            height: '48px',
            width: '48px'
        },
        onClick: function () { return onClose(); }
    }, /*#__PURE__*/ React.createElement(CrossIcon, {
        sx: {
            height: '11.67px',
            width: '11.67px'
        }
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2",
        color: mobilenoblack
    }, "Delayed")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: gray
    }, "Job card: ".concat(jobcardNo, " is delayed by ").concat(getTimeInHMS(difference))), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: mobilenoblack
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: gray
    })), /*#__PURE__*/ React.createElement(Grid, {
        mt: 1,
        item: true,
        xs: 12,
        sx: {
            border: "1px solid ".concat(faintGray),
            borderRadius: 2,
            backgroundColor: faintblue
        },
        p: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'sm',
            fontWeight: 'strong',
            color: 'text.secondary'
        }
    }, 'Doc date & time:')), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'base',
            fontWeight: 'medium',
            color: 'text.primary'
        }
    }, documentDateTime)), /*#__PURE__*/ React.createElement(Grid, {
        mt: 1,
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'sm',
            fontWeight: 'strong',
            color: 'text.secondary'
        }
    }, 'Estimated date & time:')), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'base',
            fontWeight: 'medium',
            color: 'text.primary'
        }
    }, estimatedDeliveryTime)))), /*#__PURE__*/ React.createElement(Grid, {
        mt: 1,
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        direction: IS_MOBILE ? 'column' : 'row',
        flexDirection: IS_MOBILE ? 'column' : 'row-reverse',
        justifyContent: 'end',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 5.9,
        sm: 4
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "contained",
        fullWidth: true,
        name: "Update reason",
        onClick: onClose
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 5.8,
        sm: 3
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        fullWidth: true,
        name: "Discard",
        sx: {
            color: '#6A7682',
            borderColor: faintGray
        },
        onClick: onClose
    })))));
};
